import PropTypes from "prop-types";
import { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import MUIIcons from "../MUIIcon/MUIIcons";

interface ItemProps {
  item: string;
  onClick: () => void;
}

interface IconDropdownProps {
  items: ItemProps[];
  direction: "up" | "down" | "start" | "end";
  iconName?: string;
  iconSize?: number;
  iconClassName?: string;
}

const IconDropdown: React.FC<IconDropdownProps> = ({
  items,
  direction,
  iconName = "MoreVertOutlined",
  iconSize = 24,
  iconClassName = "primary-icon-color pointer",
}) => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);

  return (
    <Dropdown isOpen={open} toggle={toggle} direction={direction}>
      <DropdownToggle
        tag="span"
        data-toggle="dropdown"
        className="bg-transparent border-0 p-0"
      >
        <MUIIcons
          iconName={iconName as any}
          size={iconSize}
          className={iconClassName}
          onClick={toggle}
        />
      </DropdownToggle>
      <DropdownMenu className="dropdown-block">
        {items.map((data, index) => (
          <DropdownItem onClick={data.onClick} key={index}>
            {data.item}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

IconDropdown.propTypes = {
  items: PropTypes.array.isRequired,
  direction: PropTypes.any.isRequired,
  iconName: PropTypes.string,
  iconSize: PropTypes.number,
  iconClassName: PropTypes.string,
};

export default IconDropdown;
